module.exports = __webpack_public_path__ + "static/ywbl1-1a0611c4669193f30bd57ac85a29666f.jpg";